import styled from "styled-components";

export const StyledSearchResultList = styled.ul`
  overflow-y: auto;
  list-style: none;
  padding: 0;
  margin: 0;
  padding-top: 11px;

  &::-webkit-scrollbar {
    width: 6px;
  }

  &::-webkit-scrollbar-track {
    box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
    border-radius: 10px;
  }

  &::-webkit-scrollbar-thumb {
    border-radius: 10px;
    background: var(--color-gray-200);
    box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.5);
  }

  &::-webkit-scrollbar-thumb:window-inactive {
    background: rgba(0, 0, 0, 0.4);
  }
`;

export const StyledSearchResultItem = styled.li`
  display: flex;
  flex-direction: row;
  align-items: top;
  gap: 20px;
  margin-bottom: 64px;
  padding: 0 5%;
`;

export const StyledLink = styled.a`
  display: inline-block;
  text-decoration: none;
  transition: 0.4s ease-in;
  text-decoration: none !important;
  color: var(--badge-link) !important;

  &:hover p {
    color: var(--primary);
  }

  &:hover {
    text-decoration: none !important;
  }
`;

export const StyledInfoWrapper = styled.div`
  display: flex;
`;

export const StyledImageWrapper = styled.div`
  @media (max-width: 768px) {
    display: none;
  }
`;

export const StyledSearchResultInfo = styled.div``;

export const StyledBadges = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: baseline;
`;

export const StyledBadge = styled.div`
  margin-right: 10px;
  margin-bottom: 10px;

  @media (min-width: 768px) {
    margin-bottom: 15px;
    margin-right: 20px;
  }
`;

export const StyledImage = styled.img`
  border-style: solid !important;
  width: 150px;
  border: 1px solid hsla(0, 0%, 43.9%, 0.5);
  border-radius: 4px;
`;
